import React from 'react'
import style from './style.css'

export default (props) => (
    <div className={`${style.formGroup} ${style[`spacer-${props.spacer || 'normal'}`]}`}>
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/formGroup.js